import React from 'react';
import { useMoveBack } from '../../hooks/useMoveBack';
import { Box, CardMedia, IconButton, Skeleton, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTheme } from '@emotion/react';
import { useStore } from '../../context/StoreProvider';

const HeaderBack = ({ title, children, isBack, top = { md: 64, xs: 44 }, onClick, path }) => {
    const moveBack = useMoveBack(path);
    const theme = useTheme();

    // ✅ التعامل الآمن مع useStore - يمكن أن يكون null
    const storeContext = useStore();
    const storeData = storeContext?.storeData;

    let lng = localStorage.getItem('i18nextLng') || 'en';

    return (
        <>
            <Box
                sx={{
                    background: { md: theme.palette.nav.main, xs: theme.palette.nav.main },
                    boxShadow: isBack && theme.palette.boxShadow,
                    display: { md: "flex", xs: "flex" },
                    justifyContent: "space-evenly",
                    width: "100%",
                    alignItems: 'center',
                    px: 2,
                    py: 1,
                    position: 'sticky',
                    top: top,
                    zIndex: 99,
                    height: 60
                }}
            >
                {isBack && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {!storeData ? (
                            <Skeleton animation="wave" height={50} width={50} />
                        ) : (
                            <>
                                <CardMedia
                                    component={'img'}
                                    src={storeData.logo}
                                    alt="logo"
                                    sx={{
                                        width: '40px',
                                        height: '40px',
                                        m: 'auto',
                                        borderRadius: '50%',
                                        objectFit: 'cover'
                                    }}
                                />
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                    <Typography
                                        color={'primary.default'}
                                        variant="body2"
                                        fontWeight={'bold'}
                                        sx={{
                                            fontSize: 14,
                                            fontFamily: 'URW DIN Arabic',
                                            fontWeight: 'medium',
                                            lineHeight: 'auto'
                                        }}
                                    >
                                        {storeData.name}
                                    </Typography>
                                    <Typography
                                        color={'primary.default'}
                                        variant="caption"
                                        sx={{
                                            fontFamily: 'URW DIN Arabic',
                                            fontWeight: 'light',
                                            fontSize: 12,
                                            lineHeight: 'auto'
                                        }}
                                    >
                                        {storeData.category?.name}
                                    </Typography>
                                </Box>
                            </>
                        )}
                    </Box>
                )}

                {!isBack && (
                    <IconButton
                        onClick={onClick || moveBack}
                        sx={{
                            display: { md: 'none', xs: 'unset' },
                            transform: `rotate(${lng === 'en' ? '180deg' : '0deg'})`,
                            position: 'absolute',
                            right: lng === 'en' ? 'auto' : 0,
                            left: lng === 'en' ? 0 : 'auto'
                        }}
                    >
                        <ArrowForwardIosIcon sx={{ fill: theme.palette.primary.default }} />
                    </IconButton>
                )}

                <Typography
                    sx={{
                        flexGrow: 1,
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontFamily: "URW DIN Arabic !important"
                    }}>
                    {title}
                </Typography>

                {children}
            </Box>
        </>
    );
};

export default HeaderBack;
